import {spro_cls_dropdownlist} from "./inputs/spro-dropdownlist/spro-dropdownlist.component";
import {spro_cls_grid} from "./grids/spro-grid/spro-grid.component";
import {spro_cls_button} from "./buttons/spro-button/spro-button.component";
import {spro_cls_button_actualiser} from "./buttons/spro-button-actualiser/spro-button-actualiser.component";
import {spro_cls_button_ajouter} from "./buttons/spro-button-ajouter/spro-button-ajouter.component";
import {spro_cls_button_annuler} from "./buttons/spro-button-annuler/spro-button-annuler.component";
import {spro_cls_button_dupliquer} from "./buttons/spro-button-dupliquer/spro-button-dupliquer.component";
import {spro_cls_button_modifier} from "./buttons/spro-button-modifier/spro-button-modifier.component";
import {spro_cls_button_supprimer} from "./buttons/spro-button-supprimer/spro-button-supprimer.component";
import {spro_cls_button_valider} from "./buttons/spro-button-valider/spro-button-valider.component";
import {spro_cls_dialog_button} from "./buttons/spro-dialog-button/spro-dialog-button.component";
import {spro_cls_grid_detail} from "./grids/spro-grid/spro-grid-detail.component";
import {spro_cls_calendar} from "./inputs/spro-calendar/spro-calendar.component";
import {spro_cls_input} from "./inputs/spro-input/spro-input.component";
import {spro_cls_checkbox} from "./inputs/spro-checkbox/spro-checkbox.component";
import {spro_cls_radio} from "./inputs/spro-radio/spro-radio.component";
import {spro_cls_input_dec} from "./inputs/spro-input-dec/spro-input-dec.component";
import {spro_cls_loading} from "./utils/spro-loading/spro-loading.component";
import {spro_cls_input_date} from "./inputs/spro-input-date/spro-input-date.component";
import {spro_cls_input_icone} from "./inputs/spro-input-icone/spro-input-icone.component";
import {spro_cls_input_int} from "./inputs/spro-input-int/spro-input-int.component";
import { spro_cls_textarea } from "./inputs/spro-textarea/spro-textarea.component";
import {noSanitize} from "./pipes/spro-pipe-noSanitize/noSanitize.pipe";
import {spro_cls_varGlobal} from "./spro-varGlobal";
import {spro_cls_chemin} from "./utils/spro-chemin/spro-chemin.component";
import {spro_cls_msg} from "./utils/spro-msg/spro-msg.component";
import {spro_cls_msg_confirmation} from "./utils/spro-msg-confirmation/spro-msg-confirmation.component";
import {spro_cls_periode_liste} from "./utils/spro-periode-liste/spro-periode-liste.component";
import {spro_cls_periode} from "./utils/spro-periode/spro-periode.component";
import {SproToasterService} from "./services/spro-toaster/spro-toaster.service";

import {NgModule} from '@angular/core';
import {IntlModule} from '@progress/kendo-angular-intl';
import {PopupModule} from '@progress/kendo-angular-popup';
import {FormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {DropDownsModule} from '@progress/kendo-angular-dropdowns';
import {InputsModule} from '@progress/kendo-angular-inputs';
import {GridModule, PDFModule, ExcelModule} from '@progress/kendo-angular-grid';
import {CommonModule} from "@angular/common";
import {DialogModule, DialogsModule} from "@progress/kendo-angular-dialog";
import {DateInputsModule} from '@progress/kendo-angular-dateinputs';
import {ContextMenuModule} from "ngx-contextmenu";

import '@progress/kendo-angular-intl/locales/de/all'; /* Allemand */
import '@progress/kendo-angular-intl/locales/de-AT/all'; /* Autrichien */
import '@progress/kendo-angular-intl/locales/en/all'; /* Anglais */
import '@progress/kendo-angular-intl/locales/fr/all'; /* Français */
import '@progress/kendo-angular-intl/locales/hu/all'; /* Hongrois */
import '@progress/kendo-angular-intl/locales/it/all'; /* Italien */
import '@progress/kendo-angular-intl/locales/pt/all'; /* Portugais */
import {ToolBarModule} from "@progress/kendo-angular-toolbar";

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    DropDownsModule,
    InputsModule,
    FormsModule,
    GridModule,
    PDFModule,
    ExcelModule,
    DialogModule,
    DateInputsModule,
    PopupModule,
    IntlModule,
    ToolBarModule,
    DialogsModule,
    ContextMenuModule.forRoot({
      autoFocus: true,
    }),
  ],
  declarations: [
    spro_cls_button,
    spro_cls_button_actualiser,
    spro_cls_button_ajouter,
    spro_cls_button_annuler,
    spro_cls_button_dupliquer,
    spro_cls_button_modifier,
    spro_cls_button_supprimer,
    spro_cls_button_valider,
    spro_cls_calendar,
    spro_cls_checkbox,
    spro_cls_chemin,
    spro_cls_dialog_button,
    spro_cls_dropdownlist,
    spro_cls_grid,
    spro_cls_grid_detail,
    spro_cls_input,
    spro_cls_input_dec,
    spro_cls_input_int,
    spro_cls_input_date,
    spro_cls_input_icone,
    spro_cls_textarea,
    spro_cls_loading,
    spro_cls_msg,
    spro_cls_msg_confirmation,
    spro_cls_periode,
    spro_cls_periode_liste,
    spro_cls_radio,
    noSanitize,
  ],
  exports: [
    spro_cls_button,
    spro_cls_button_actualiser,
    spro_cls_button_ajouter,
    spro_cls_button_annuler,
    spro_cls_button_dupliquer,
    spro_cls_button_modifier,
    spro_cls_button_supprimer,
    spro_cls_button_valider,
    spro_cls_calendar,
    spro_cls_checkbox,
    spro_cls_chemin,
    spro_cls_dialog_button,
    spro_cls_dropdownlist,
    spro_cls_grid,
    spro_cls_grid_detail,
    spro_cls_input,
    spro_cls_input_dec,
    spro_cls_input_int,
    spro_cls_input_date,
    spro_cls_input_icone,
    spro_cls_textarea,
    spro_cls_loading,
    spro_cls_msg,
    spro_cls_msg_confirmation,
    spro_cls_periode,
    spro_cls_periode_liste,
    spro_cls_radio,
    DialogsModule,
  ],
  providers: [
    spro_cls_varGlobal,
    SproToasterService
  ],
})
export class SproLibModule {}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/sproLib/spro/spro-lib.module.ts